import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Add({ open, onClose, refreshData, onAddCustomer }) {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    numero: '',
    adresse: '',
    code_postal: '',
    ifu: '',
    fidelite: 'Actif',
    store_id: null,
    user_id: null,
    is_r: false,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  const fetchUserData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/user-info`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
      const fetchedUser = response.data.data;
      setUser(fetchedUser);
      setFormData((prev) => ({
        ...prev,
        store_id: fetchedUser?.stores?.[0]?.id || fetchedUser?.personnels?.[0]?.store_id || '',
        user_id: fetchedUser?.id || '',
      }));
      localStorage.setItem('user', JSON.stringify(fetchedUser));
    } catch (error) {
      console.error('Erreur lors de la récupération des données utilisateur :', error);
    }
  };

  useEffect(() => {
    if (open) fetchUserData();
  }, [open]);

  if (!open) return null;

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      numero: '',
      adresse: '',
      code_postal: '',
      ifu: '',
      fidelite: 'Actif',
      store_id: user?.stores?.[0]?.id || user?.personnels?.[0]?.store_id || '',
      user_id: user?.id || '',
      is_r: false,
    });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/customers`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const newCustomer = response.data.data;

      await Swal.fire({
        icon: 'success',
        title: 'Client ajouté',
        text: response.data.message || 'Le client a été ajouté avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData?.();
      onAddCustomer?.(newCustomer);
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: "Une erreur est survenue lors de l'ajout du client.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter un client"
      onClose={handleClose}
      size="lg"
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="submit" form="add-customer-form" className="duo-btn duo-btn--primary" disabled={isLoading}>
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-customer-form" onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-12">
            <div className="duo-form-group">
              <label htmlFor="add-customer-name" className="duo-form-label">
                Nom du client *
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-customer-name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <p className="text-danger small mt-1 mb-0">{errors.name[0]}</p>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-customer-email" className="duo-form-label">
                Email
              </label>
              <input
                type="email"
                className="duo-input"
                id="add-customer-email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="text-danger small mt-1 mb-0">{errors.email[0]}</p>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-customer-numero" className="duo-form-label">
                Téléphone *
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-customer-numero"
                name="numero"
                value={formData.numero}
                onChange={handleChange}
              />
              {errors.numero && <p className="text-danger small mt-1 mb-0">{errors.numero[0]}</p>}
            </div>
          </div>
          <div className="col-md-4">
            <div className="duo-form-group">
              <label htmlFor="add-customer-adresse" className="duo-form-label">
                Adresse
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-customer-adresse"
                name="adresse"
                value={formData.adresse}
                onChange={handleChange}
              />
              {errors.adresse && <p className="text-danger small mt-1 mb-0">{errors.adresse[0]}</p>}
            </div>
          </div>
          <div className="col-md-4">
            <div className="duo-form-group">
              <label htmlFor="add-customer-code_postal" className="duo-form-label">
                Code postal
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-customer-code_postal"
                name="code_postal"
                value={formData.code_postal}
                onChange={handleChange}
              />
              {errors.code_postal && <p className="text-danger small mt-1 mb-0">{errors.code_postal[0]}</p>}
            </div>
          </div>
          <div className="col-md-4">
            <div className="duo-form-group mb-0">
              <label htmlFor="add-customer-ifu" className="duo-form-label">
                IFU
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-customer-ifu"
                name="ifu"
                value={formData.ifu}
                onChange={handleChange}
              />
              {errors.ifu && <p className="text-danger small mt-1 mb-0">{errors.ifu[0]}</p>}
            </div>
          </div>
        </div>
      </form>
    </DuoModal>
  );
}
